const IST_TIMEZONE = 'Asia/Kolkata';

/** Panel visible 14:45–15:00 IST (2:45–3:00 PM). */
export function isClosingMomentumPanelWindow(date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: IST_TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(date);
    const hour = Number(parts.find((p) => p.type === 'hour')?.value ?? 0);
    const minute = Number(parts.find((p) => p.type === 'minute')?.value ?? 0);
    const clock = hour * 60 + minute;
    const start = 14 * 60 + 45;
    const end = 15 * 60;
    return clock >= start && clock <= end;
  } catch {
    return false;
  }
}

export function formatIstClock(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleTimeString('en-IN', {
      timeZone: IST_TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return String(iso);
  }
}

export const UI_STATE_STYLES = {
  gathering: 'bg-slate-100 text-slate-700 border-slate-200',
  armed: 'bg-amber-50 text-amber-800 border-amber-200',
  watching: 'bg-blue-50 text-blue-800 border-blue-200',
  triggered: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  idle: 'bg-gray-50 text-gray-600 border-gray-200',
};

export const UI_STATE_LABELS = {
  gathering: 'Gathering',
  armed: 'ARMED',
  watching: 'Trigger Window',
  triggered: 'TRIGGERED',
  idle: 'Waiting',
};
